import React from 'react'
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { decode_utf8, urlParams } from "../../../../common/utils/utilsFunc";
import ResponseLetterContextProvider, { ACTIONS, ResponseLetterContext } from "../../context/ResponseLetterContextProvider";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function ResponseLetter({ props }) {
    const [state, dispatch] = React.useContext(ResponseLetterContext)
    const [numApplication, setNumApplication] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState("");
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
            setError(false);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    React.useEffect(() => {
        const NumIdParam = urlParams.get('id')

        if (NumIdParam) {
            setNumApplication(NumIdParam)
        } else {
            setNumApplication(null)
        }
    }, [])

    function handleClickButton() {
        if (numApplication && verifReCaptcha) {
            setLoading(true)
            dispatch({
                payload: numApplication,
                type: ACTIONS.SET_NUM_ID,
            });
            setError(false)
            setErrorMsg("")
        } else if (!numApplication) {
            setError(true)
            setErrorMsg("No posee número de aviso asociado")
        } else if (!verifReCaptcha) {
            setError(true)
            setErrorMsg("Falta validar que no eres un Robot")
        }
    }

    React.useEffect(() => {
        if (state.responseLetter) {
            setLoading(false)
            dispatch({
                payload: null,
                type: ACTIONS.SET_NUM_ID,
            });
            if (state.responseLetter.status === 500) {
                setError(true)
                setErrorMsg(decode_utf8(props.text_fetch_error))
            } else if (state.responseLetter.status === 1) {
                setError(true)
                setErrorMsg(state.responseLetter.message)
            } else {
                setError(false)
            }
        }
    }, [state.responseLetter])

    React.useEffect(() => {
        if (state.errorFetch) {
            setError(true)
            setErrorMsg(decode_utf8(props.text_fetch_error))
        } else {
            setError(false)

        }
    }, [state.errorFetch])

    React.useEffect(() => {
        if (error) {
            props.setGlobalAlert(errorMsg, "warning", true, "Advertencia");
        }
    }, [error])

    return (
        <CGE.Panel title={decode_utf8(props.title_response_letter_sms)} >
            <CGE.PanelContainer
                size="md"
                alingItensCenter={true}
            >
                <CGE.Spacing type="nl" />
                <CGE.FormsField
                    horizontal={true}
                    labelName="Numero de aviso"
                    idFormElement="numApplication"
                    typeFormElement="text"
                    mandatoryElement={true}
                    typeElement={'input'}
                    value={numApplication}
                    readOnly={true}
                />
                <CGE.FieldRecaptcha
                    onChange={onChangeReCaptcha}
                    sitekey={props.api_key_recaptcha}
                    horizontal={true}
                />
            </CGE.PanelContainer>
            <CGE.Button
                label="Descargar"
                onClick={handleClickButton}
                className="mx-auto"
            />
            {loading && <Loading />}
        </CGE.Panel>
    )
}

const ResponseLetterWithProvider = ({
    props

}) => (
    <ResponseLetterContextProvider>
        <ResponseLetter
            props={props}
        />
    </ResponseLetterContextProvider>
);

export default ResponseLetterWithProvider;